<div *ngFor="let block of blocks; index as i">
  <app-image-block
    *ngIf="block.type == 'image-block'"
    [title]="block.title"
    [image]="block.image"
    [text]="block.text"
    [position]="i % 2 === 0 ? 'left' : 'right'"
    [style.background-color]="
      i % 2 === 0 ? 'white' : '#f2f2f2'
    "></app-image-block>
  <app-video-block
    *ngIf="block.type == 'video-block'"
    [title]="block.title"
    [position]="i % 2 === 0 ? 'left' : 'right'"
    [style.background-color]="
      i % 2 === 0 ? 'white' : '#f2f2f2'
    "></app-video-block>
</div>
